/* eslint-disable i18next/no-literal-string */

import type { FeedbackSendingMethod, ParsedContact } from '@aikoa/common'

export function getAvailableFeedbackSendingMethods(
  contacts: Pick<ParsedContact, 'phone' | 'email'>[]
): FeedbackSendingMethod[] {
  const methods: FeedbackSendingMethod[] = []

  if (contacts.some((contact) => !!contact.phone)) {
    methods.push('sms')
  }

  if (contacts.some((contact) => !!contact.email)) {
    methods.push('email')
  }

  return methods
}

export function resolveFeedbackSendingMethod(
  preferred: FeedbackSendingMethod | null | undefined,
  available: FeedbackSendingMethod[]
): FeedbackSendingMethod | null {
  if (preferred && available.includes(preferred)) {
    return preferred
  }

  return available[0] ?? null
}
